import QueueModalWrapper from "./QueueModalWrapper";
import {TextArea} from "@varymadellc/my-weed-club-component-library";
import {Button} from "@varymadellc/my-weed-club-component-library";
import React, {useState} from "react";
import {useAuth} from "../../../providers/AuthProvider";
import {apiPost, extractPayloadFromResponse} from "../../../services/apiService";
import {useSiteMessage} from "../../../providers/SiteMessageProvider";

export interface QueueModalTextProps {
    setIsOpen: (value: string) => void;
    requestRefresh?: () => void;
}

export default function QueueModalText({setIsOpen, requestRefresh}: QueueModalTextProps) {
    const {authToken} = useAuth();

    const {setMessage} = useSiteMessage();

    const [text, setText] = useState<string>('');

    const [, setDescription] = useState<string>('');

    const setIsOpenHandler = (value: string) => {
        if (!value) {
            setText('');

            setDescription('');

            setIsOpen(value || '');
        }
    }

    const onSubmitHandler = (event: any) => {
        event.preventDefault();

        async function postData() {
            try {
                if (!text) {
                    throw new Error('Text is required');
                }

                if (text.length < 1) {
                    throw new Error('Text is too short');
                }

                const response = await apiPost('/q', JSON.stringify({
                    type: 'text',
                    metadata: {
                        text
                    }
                }), authToken);

                const {data: queueItem} = await extractPayloadFromResponse(response);

                if (queueItem) {
                    setMessage('Text added to Queue');

                    setIsOpen('');

                    requestRefresh && requestRefresh();
                }
            } catch(error: any) {
                setMessage(error.message);
            }
        }

        postData();
    };

    return (
        <QueueModalWrapper setIsOpen={setIsOpenHandler}>
            <div className="relative flex flex-col w-full md:min-w-[600px]">
                <h2>Add Text</h2>
                <hr className="mt-2"/>
                <form onSubmit={onSubmitHandler} className="flex flex-col gap-4">
                    <label htmlFor="text">Text (say something)</label>
                    <TextArea name="text" onChange={({target: {value}}: any) => setText(value)}/>
                    <Button type="submit">Add</Button>
                </form>
            </div>
        </QueueModalWrapper>
    );
}